import { render, staticRenderFns } from "./SchoolPickerDuplikaty.vue?vue&type=template&id=58ca9fd6&"
import script from "./SchoolPickerDuplikaty.vue?vue&type=script&lang=js&"
export * from "./SchoolPickerDuplikaty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports